import React, { FC, PropsWithChildren, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { useIdTokenClaims, usePageAccess } from '@/hooks';

import { pushDataLayerEvent } from './analytics/dataLayer';
import { getPageTitle } from './analytics/getPageTitle';
import { reportWebVitals } from './analytics/reportWebVitals';

export const GoogleAnalytics: FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  const pages = usePageAccess();
  const { idTokenClaims } = useIdTokenClaims();

  const user = useMemo(
    () => idTokenClaims?.signInName,
    [idTokenClaims?.signInName],
  );

  const pagePath = `${location.pathname}${location.search}`;
  const pageTitle = getPageTitle(location.pathname, pages);
  const pageLocation = `${window.location.origin}${pagePath}${location.hash}`;

  useEffect(() => {
    reportWebVitals();
  }, []);

  useEffect(() => {
    document.title = pageTitle;

    // Keep event name "Page View" for existing GTM Custom Event triggers.
    // Flat page_* fields match GA4 / GTM SPA virtual pageview mapping.
    pushDataLayerEvent({
      event: 'Page View',
      page_path: pagePath,
      page_location: pageLocation,
      page_title: pageTitle,
      user,
    });
  }, [pagePath, pageLocation, pageTitle, user]);

  return children as React.ReactElement;
};
